// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3802":"fd0baa18","4332":"99927add","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};